export default __webpack_public_path__ + "static/media/react.caee8597.png";